import { step } from '../components/bbcommon/utils/grid';
import { TLayout } from '../themes/types';

const getGridGapSpacing = (gapSpacing: TLayout) =>
  Array.isArray(gapSpacing) ? gapSpacing.map((item) => step(item)) : step(gapSpacing);

export default getGridGapSpacing;
